/** FA catalog — FE-5: تقویم، نوبت‌ها، روزِ من، زمان‌بندی هوشمند. */
export const schedFa: Record<string, string> = {
  'cal.title': 'تقویم',
  'cal.subDay':
    'یک روز، همه درمانگران کنار هم. نمای «بر اساس اتاق» همان روز را بر اساس اتاق‌ها نشان می‌دهد.',
  'cal.subWeek':
    'هر هفت روز، از ۸ تا ۲۲ با اسکرول. هر نوبت نام خدمتش را روی خودش دارد و لایه‌های کم‌رنگ و هاشورخورده می‌گویند چرا یک زمان در دسترس نیست.',
  'cal.subList':
    'همان تقویم به‌صورت جدول: برای پیدا کردن، فیلتر کردن و مرور — روی قرارداد صفحه‌بندی ثابت.',
  'cal.mine.sub': 'برنامهٔ خودتان: نوبت‌هایی که به نام شماست، به روز، به هفته، یا به شکل فهرست.',
  'cal.mine.colSub': 'جلسات شما',
  'cal.new': 'جلسه جدید',
  'cal.newGroup': 'جلسهٔ گروهی تازه',
  'cal.f.online': 'آنلاین',
  'grp.block': 'جلسه گروهی',
  'grp.count': '{n, plural, =0 {هنوز شرکت‌کننده‌ای نیست} one {# شرکت‌کننده} other {# شرکت‌کننده}}',
  'grp.countOf': '{n, number} از {cap, number} شرکت‌کننده',
  'grp.exec.scheduled': 'برنامه‌ریزی‌شده',
  'grp.exec.in_progress': 'در جریان',
  'grp.exec.completed': 'پایان‌یافته',
  'grp.exec.cancelled': 'لغو شده',
  'cal.view.day': 'روز',
  'cal.view.week': 'هفته',
  'cal.view.list': 'فهرست',
  'cal.lens.practitioner': 'بر اساس درمانگر',
  'cal.lens.room': 'بر اساس اتاق',
  'cal.earlier': 'قبل',
  'cal.today': 'امروز',
  'cal.later': 'بعد',
  'cal.f.practitioner': 'درمانگر',
  'cal.f.room': 'اتاق',
  'cal.f.service': 'خدمت',
  'cal.f.status': 'وضعیت',
  'cal.f.mode': 'شیوه ارائه',
  'cal.f.patient': 'مراجع',
  'cal.f.all': 'همه',
  'cal.noRoomCol': 'بدون اتاق',
  'cal.noRoomColSub': 'نوبت‌های بدون اتاقِ مشخص',
  'cal.f.bookedOnly': 'فقط رزرو شده',
  'cal.f.cancelled': 'لغو شده',
  'cal.f.noShow': 'نیامد',
  'cal.f.range': 'بازه',
  'cal.range.day': 'این روز',
  'cal.range.week': 'این هفته',
  'cal.range.month': '۳۱ روز',
  'cal.noColumns':
    'درمانگری برای نمایش نیست — یکی را در فیلتر انتخاب کنید، یا پروفایل درمانگر را در تنظیمات مرکز اضافه کنید.',
  'cal.noRooms': 'اتاقی برای نمایش نیست — اتاق‌ها را در تنظیمات مرکز اضافه کنید.',
  'cal.empty': 'در این بازه نوبتی نیست.',
  'cal.holiday.label': 'تعطیل رسمی',
  'cal.holiday.inRange': 'تعطیلات رسمی در این بازه',
  'cal.outside': 'خارج از ساعت کاری',
  'cal.absence': 'مرخصی',
  'cal.blockout': 'اتاق در دسترس نیست',
  'cal.legendTitle': 'راهنما',
  'cal.group.speech': 'گفتاردرمانی',
  'cal.group.ot': 'کاردرمانی',
  'cal.group.assess': 'ارزیابی و مشاوره',
  'cal.group.coach': 'آموزش والدین',
  'cal.group.other': 'خدمات دیگر',
  'cal.legendGhost': 'لغو / نیامدن',
  'cal.legendOutside': 'خارج از ساعت کاری',
  'cal.legendAbsence': 'مرخصی / اتاق در دسترس نیست',
  'cal.agendaSub': 'روی گوشی، روز یک فهرست است — همان فیلترها بالای آن قرار دارند.',
  'cal.listNoSearch':
    'پیداکردن بر اساس مراجع: یکی را با فیلتر «مراجع» انتخاب کنید. پرس‌وجوی نوبت‌ها عمداً جست‌وجوی متنی ندارد.',
  'cal.colWhen': 'چه زمانی',
  'cal.colPatient': 'مراجع',
  'cal.colService': 'خدمت',
  'cal.colPractitioner': 'درمانگر',
  'cal.colMode': 'شیوه · اتاق',
  'cal.colStatus': 'وضعیت',
  'cal.pickPatient': 'یک مراجع انتخاب کنید',
  'cal.clearPatient': 'هر مراجعی',
  'cal.slotHint': 'روی زمان خالی بزنید تا نوبتی از همان‌جا شروع شود.',
  'cal.tooWide': 'این بازه از آنچه سامانه مرکز یک‌جا ارائه می‌دهد بزرگ‌تر است (۹۳ روز).',

  'bk.status.booked': 'رزرو شده',
  'bk.status.cancelled': 'لغو شده',
  'bk.status.no_show': 'نیامد',
  'bk.delivered': 'برگزار شد',
  'bk.mode.in_clinic': 'در مرکز',
  'bk.mode.off_site': 'در خانه',
  'bk.mode.online': 'آنلاین',
  'bk.modeNotOffered':
    'این خدمت در این شیوه ارائه نمی‌شود — آن را در تنظیمات مرکز › خدمات فعال کنید.',
  'bk.modeNotOfferedChip': 'ارائه نمی‌شود',
  // ZOY-684: the join destination of an online session.
  'bk.dest.title': 'جلسه از کجا برگزار می‌شود',
  'bk.dest.hosted': 'ویدئوی زویار',
  'bk.dest.hostedBody':
    'میزبانی زویار. درمانگر از این‌جا وارد می‌شود؛ خانواده از برنامه وارد می‌شود. ۱۵ دقیقه پیش از شروع باز می‌شود.',
  'bk.dest.external': 'لینک جلسهٔ بیرونی',
  'bk.dest.externalBody':
    'یک لینک روی محصولی دیگر (گوگل‌میت، اسکای‌روم…). خانواده آن را از طریق برنامه دریافت می‌کند.',
  'bk.dest.url': 'لینک جلسه',
  'bk.dest.urlHelp':
    'یک لینک کامل https://. همان‌طور که داده‌شده ذخیره می‌شود؛ هیچ‌وقت در صفحه‌های پرداخت نشان داده نمی‌شود.',
  'bk.dest.urlInvalid': 'یک لینک کامل https:// بدون نام کاربری یا رمز وارد کنید.',
  'bk.dest.pickOne': 'یک جلسه آنلاین پیش از ذخیره شدن به یک مقصد نیاز دارد.',
  'bk.dest.fact': 'ورود',
  'bk.dest.copy': 'کپی لینک',
  'bk.dest.copied': 'کپی شد',
  'bk.dest.open': 'باز کردن لینک',
  'bk.dest.none': 'هنوز مقصدی ندارد',
  'bk.dest.leaveOnlineTitle': 'از شیوهٔ آنلاین خارج شود؟',
  'bk.dest.leaveOnlineBody':
    'مقصد اتصال همراه با شیوه پاک می‌شود — خانواده دیگر راهی برای اتصال آنلاین نخواهد داشت. اگر جلسه دوباره آنلاین شود، لینک می‌تواند دوباره وارد شود.',
  'bk.dest.leaveOnlineCta': 'تغییر شیوه',
  'bk.enter': 'ورود به جلسه',
  'bk.enterHint': '۱۵ دقیقه پیش از شروع باز می‌شود و تا پایان برنامه‌ریزی‌شده باز می‌ماند.',
  'bk.enterBefore': 'در ۱۵ دقیقه پیش از شروع باز می‌شود.',
  'bk.enterClosed': 'جلسه تمام شده — در بسته است.',
  'bk.enterErr.ONLINE_SESSION_NOT_HOSTED': 'این جلسه با زویار میزبانی نمی‌شود.',
  'bk.enterErr.ONLINE_SESSION_NOT_READY':
    'اتاق ویدیو هنوز آماده نیست — پلتفرم پاسخ نداده. کمی بعد دوباره تلاش کنید.',
  'bk.enterErr.ONLINE_SESSION_JOIN_WINDOW_CLOSED':
    'در بسته است: پیش از ۱۵ دقیقه به شروع، یا بعد از پایان برنامه‌ریزی‌شده.',
  'bk.enterErr.ONLINE_SESSION_PLATFORM_UNAVAILABLE': 'سکوی ویدئو پاسخ نداد — دوباره بزنید.',
  // Product 2026-09-16: the T−15 lock.
  'bk.lockedNote':
    'جلسه آنلاین باز شده (۱۵ دقیقه پیش از شروع)، بنابراین دیگر نمی‌توان آن را جابه‌جا یا لغو کرد. غیبت، شروع و ارائه باز می‌مانند.',
  'bk.lockedShort': 'باز شده — دیگر جابه‌جا نمی‌شود',
  'bk.v.BOOKING_ROOM_NOT_ALLOWED_ONLINE': 'جلسه آنلاین اتاق ندارد.',
  'bk.v.BOOKING_JOIN_DESTINATION_REQUIRES_ONLINE': 'مقصد اتصال فقط مال جلسه آنلاین است.',
  'bk.v.BOOKING_JOIN_URL_INVALID': 'لینک جلسه باید یک نشانی کامل https:// بدون اطلاعات ورود باشد.',
  'bk.v.BOOKING_JOIN_URL_NOT_ALLOWED': 'لینک جلسه فقط با مقصد خارجی می‌آید.',
  'bk.v.BOOKING_GROUP_PARTICIPATION_FOLLOWS_OCCURRENCE':
    'این نوبت بخشی از یک جلسهٔ گروهی است — زمان روی خودِ جلسهٔ گروهی جابه‌جا می‌شود.',
  'bk.v.BOOKING_ONLINE_SESSION_LOCKED':
    'جلسه آنلاین از قبل باز شده؛ دیگر نمی‌توان آن را جابه‌جا یا لغو کرد.',
  'bk.v.SUGGEST_LOCATION_NOT_ENABLED': 'این خدمت در این شیوه ارائه نمی‌شود.',
  // ZOY-685: a participant's booking page.
  'bk.groupChip': 'جلسه گروهی',
  'bk.groupPart':
    'بخشی از یک جلسهٔ گروهی — زمان، درمانگر، اتاق و مقصدش روی جلسهٔ گروهی مدیریت می‌شود؛ این نوبت بسته، برگزاری و پرداخت خودش را نگه می‌دارد.',
  'bk.openGroup': 'باز کردن جلسه گروهی',
  'bk.isGroupServiceTitle': 'این یک خدمت گروهی است',
  'bk.isGroupServiceBody':
    'خدمات گروهی به‌صورت یک جلسه با چند شرکت‌کننده اجرا می‌شوند. جلسه گروهی را بسازید، بعد شرکت کنندگانش را اضافه کنید — در این‌جا چیزی برای یک مراجع رزرو نمی‌شود.',
  'bk.isGroupServiceCta': 'به‌جایش یک جلسهٔ گروهی بساز',
  'bk.next': 'بعدی',
  'bk.past': 'گذشته',

  'bk.newTitle': 'جلسه جدید',
  'bk.newSub':
    'نوبت از یک جای خالی شروع می‌شود، خدمتش را نام می‌برد، در همین جریان روشن می‌کند برای کیست و ادامه می‌یابد. تا پیش از ثبت همه‌چیز قابل‌تغییر است.',
  'bk.newSubFrom': 'از {when} در ستون {who} شروع شد — همه‌چیز تا ذخیره شدن قابل‌ویرایش است.',
  'bk.step1': '۱ · خدمت و برای کیست',
  'bk.step2': '۲ · زمان، درمانگر، مکان',
  'bk.service': 'خدمت',
  'bk.serviceHelp': 'هیچ نوبتی بدون خدمت وجود ندارد. از فهرست؛ فقط خدمت‌های فعال.',
  'bk.for': 'برای',
  'bk.forHelp':
    'در همین جریان مشخص می‌شود: مراجع تثبیت شده ادامه می‌دهد؛ اولین تماس از جستجوی شماره و ثبت حداقلی می‌گذرد. اولین تماس‌ها همیشه دستی رزرو می‌شوند — هیچ‌وقت از طریق زمان‌بندی هوشمند.',
  'bk.changePatient': 'تغییر',
  'bk.practitioner': 'درمانگر',
  'bk.practitionerHelp': 'فقط درمانگرانی که توانایی این خدمت را دارند پیشنهاد می‌شوند.',
  'bk.noCapable':
    'هنوز هیچ درمانگری توانایی این خدمت را ندارد — آن را در تنظیمات مرکز › خدمات بدهید.',
  'bk.date': 'تاریخ',
  'bk.from': 'از ساعت',
  'bk.duration': 'مدت',
  'bk.durationHelp': 'از مدت پیش‌فرض خدمت پیش‌پر می‌شود — آزادانه عوضش کنید.',
  'bk.min': 'دقیقه',
  'bk.mode': 'شیوه ارائه',
  'bk.modeHelp':
    'در مرکز می‌تواند اتاق داشته باشد؛ در خانه نشانی ملاقات روی نوبت می‌نشیند؛ آنلاین از راه لینک جلسه یا ویدئوی زویار برگزار می‌شود.',
  'bk.room': 'اتاق',
  'bk.roomHelp':
    'هیچ‌وقت خودکار انتخاب نمی‌شود، و همیشه هم لازم نیست؛ فقط اتاق‌هایی که این خدمت را پشتیبانی می‌کنند.',
  'bk.noRoom': 'بدون اتاق',
  'bk.package': 'بسته',
  'bk.packageHelp': 'اختیاری — نوبت بدون بسته هم کاملاً معتبر است.',
  'bk.packageChoiceTitle': 'این جلسه از کدام بسته برود؟',
  'bk.packageChoiceSub':
    'بسته‌هایی که همین خدمت را دارند. هیچ‌چیزی خودکار انتخاب نمی‌شود؛ پذیرش تصمیم می‌گیرد.',
  'bk.packageCard': '{planned} برنامه‌ریزی‌شده · {remaining} باقی‌مانده برای برنامه‌ریزی · {prov}',
  'bk.overScheduleReason': 'دلیل رزرو بیش از برنامه (اختیاری)',
  'bk.overScheduleReasonHelp': 'روی نوبت می‌ماند برای هرکس که پکیج را بازبینی می‌کند.',
  'bk.warnOverTitle': 'رزرو فراتر از برنامهٔ پکیج',
  'bk.warnOverBody':
    '{planned} برنامه‌ریزی‌شده · {delivered} تحویل‌شده · {scheduled} رزروشده — {over, number} نوبت فراتر از برنامه، همین یکی هم حساب است. نوبت تأیید شده؛ جلسهٔ فراتر از برنامه با قیمت فهرست خدمات تحویل می‌شود.',
  'bk.warnUpfrontTitle': 'انتظار پرداخت پیشاپیش',
  'bk.warnUpfrontBody':
    'این پکیج پرداخت پیشاپیش انتظار دارد: {received} از {total} دریافت شده، {shortfall} مانده. نوبت تأیید شده — این فقط اطلاعی برای پذیرش است.',
  'bk.warnDismiss': 'متوجه شدم',
  'bk.overReasonLine': 'بیش از برنامه رزرو شد — {reason}',
  'bk.packageOver': '{n, number} نوبت فراتر از برنامه',
  'bk.packageOverDelivered': '{n, number} تحویل فراتر از برنامه',
  'bk.noPackage': 'بدون بسته',
  'bk.noPackageBody': 'یک جلسه موردی معتبر — هیچ خدمتی هیچ‌وقت به زور داخل بسته نمی‌رود.',
  'bk.overSchedule':
    'این سطر جلسه‌ای برای برنامه‌ریزی ندارد ({planned} برنامه‌ریزی‌شده · {delivered} ارائه شده · {scheduled} برنامه‌ریزی‌شده). رزرو همچنان انجام می‌شود — بسته بیش از برنامه‌اش خواهد بود، و جلسه‌ای بیش از برنامه با قیمت فهرست ارائه می‌شود.',
  'bk.address': 'نشانی ویزیت',
  'bk.addressHelp':
    'از پرونده پر شده — برای همین نوبت قابل‌ویرایش است و روی نوبت ثبت می‌شود؛ جای تازه‌ای اختراع نمی‌شود.',
  'bk.travel': 'زمان سفر',
  'bk.travelHelp':
    'دقیقه در هر مسیر، فقط برای ویزیت خانگی — برای هر نوبت قابل‌ویرایش. خالی بماند، پیش‌فرض مرکز یعنی {n} دقیقه در هر مسیر اعمال می‌شود (تنظیمات مرکز ← نمایه).',
  'bk.travelHelpUnknown':
    'دقیقه در هر مسیر، فقط برای ویزیت خانگی — برای هر نوبت قابل‌ویرایش. خالی بماند، پیش‌فرض مرکز اعمال می‌شود؛ آن پیش‌فرض الان خوانده نشد، پس اینجا نشان داده نمی‌شود.',
  'bk.capableFailed': 'این گزینه‌ها بارگذاری نشدند، پس این فهرست ناقص است.',
  'bk.capableFailedTitle': 'برخی گزینه‌ها بارگذاری نشدند',
  'bk.capableFailedBody':
    'درمانگران و اتاق‌هایی که این خدمت را پشتیبانی می‌کنند خوانده نشدند، پس آن فهرست‌ها ناقص اند — این به‌معنای نبودنشان نیست. دوباره تلاش کنید، و اگر باز هم نشد از مدیر مرکز بخواهید.',
  'bk.confirm': 'ثبت نوبت',
  'bk.saveNote':
    'محدودیت‌های سخت هنگام ذخیره بررسی می‌شوند — اگر ناموفق بود، هیچ‌چیز از آنچه نوشتید از بین نمی‌رود.',
  'bk.suggest': 'پیشنهاد زمان',
  'bk.suggestSub':
    'زمان‌بندی هوشمند بازه‌های معتبر برای این جلسه بسته پیشنهاد می‌دهد — فقط مشورتی؛ یکی را انتخاب کنید تا فرم پر شود.',
  'bk.suggestNone': 'در {days, number} روز آینده بازه معتبری نیست.',
  'bk.suggestPick': 'استفاده از این',
  'bk.whoFirst': 'اول خدمت و مراجع را انتخاب کنید.',

  'bk.refusedTitle': 'ذخیره رد شد — {n, plural, one {# تعارض} other {# تعارض، همه با هم}}',
  'bk.refusedBody':
    'چیزی ثبت نشد — و چیزی هم از دست نرفت. همهٔ آنچه تایپ کرده‌اید سر جای خودش است. تداخل‌ها را برطرف کنید و دوباره ثبت کنید.',
  'bk.noOverrideTitle': 'چرا راه دور زدن نیست',
  'bk.noOverrideBody':
    'مرخصی، تعارض اتاق و هم‌پوشانی خود مراجع، محدودیت‌های سخت سامانه مرکز اند؛ رابط کاربری راهی برای دور زدنشان نمی‌سازد.',
  'bk.way.time': 'زمان دیگری انتخاب کنید',
  'bk.way.practitioner': 'تغییر درمانگر',
  'bk.way.room': 'تغییر اتاق',
  'bk.v.BOOKING_PATIENT_OVERLAP': 'خود مراجع در همین بازه نوبت دیگری دارد.',
  'bk.v.BOOKING_PRACTITIONER_OVERLAP': 'درمانگر در این بازه نوبت دیگری دارد.',
  'bk.v.BOOKING_ROOM_OVERLAP': 'اتاق در این بازه نوبت دیگری دارد.',
  // ZOY-650: the gap alone is the reason (the sessions do not touch).
  'bk.gap.practitioner':
    'درمانگر به فاصله {n, plural, one {# دقیقه‌ای} other {# دقیقه‌ای}} مرکز پیش از این جلسه نیاز دارد — جلسه قبلی خیلی نزدیک تمام می‌شود. {n, plural, one {# دقیقه} other {# دقیقه}} بعد از پایانش یا دیرتر شروع کنید.',
  'bk.gap.room':
    'اتاق به فاصله {n, plural, one {# دقیقه‌ای} other {# دقیقه‌ای}} خودش پیش از این جلسه نیاز دارد — جلسه قبلی داخلش خیلی نزدیک تمام می‌شود.',
  'bk.v.BOOKING_OUTSIDE_WORKING_HOURS':
    'خارج از ساعات کاری درمانگر — روی تقویم به‌صورت ناحیه رنگی دیده می‌شود.',
  'bk.v.BOOKING_PRACTITIONER_TIME_OFF':
    'درمانگر آن موقع در مرخصی است — روی تقویم به‌صورت لایه‌هاشور خورده دیده می‌شود.',
  'bk.v.BOOKING_PRACTITIONER_NOT_CAPABLE': 'درمانگر توانایی این خدمت را ندارد.',
  'bk.v.BOOKING_PRACTITIONER_NOT_ACTIVE_MEMBER': 'درمانگر عضو فعال این مرکز نیست.',
  'bk.v.BOOKING_DAILY_CAP_EXCEEDED': 'سقف جلسات روزانه درمانگر رد می‌شود.',
  'bk.v.BOOKING_WEEKLY_CAP_EXCEEDED': 'سقف جلسات هفتگی درمانگر رد می‌شود.',
  'bk.v.BOOKING_SERVICE_NOT_BOOKABLE': 'این خدمت در این مرکز قابل‌رزرو نیست.',
  'bk.v.BOOKING_SERVICE_PRICE_NOT_CONFIGURED':
    'این خدمت هنوز قیمت ندارد — قیمت‌گذاری در تنظیمات مرکز → خدمات پیش از رزرو تعیین می‌شود.',
  'bk.v.BOOKING_SERVICE_LOCATION_NOT_ENABLED': 'این خدمت در این شیوه ارائه نمی‌شود.',
  'bk.v.BOOKING_ROOM_DISABLED': 'اتاق غیرفعال است.',
  'bk.v.BOOKING_ROOM_NOT_CAPABLE': 'اتاق برای این خدمت تنظیم نشده است.',
  'bk.v.BOOKING_ROOM_OUTSIDE_WORKING_HOURS':
    'خارج از ساعات اتاق — در تنظیمات مرکز › اتاق‌ها، روی خود اتاق تعیین می‌شود.',
  'bk.v.BOOKING_ROOM_BLOCKOUT': 'اتاق آن موقع مسدود است.',
  'bk.v.BOOKING_INVALID_RANGE': 'پایان باید بعد از شروع باشد.',
  'bk.v.BOOKING_PACKAGE_STOPPED':
    'این بسته (یا این خدمتِ آن) با «پایان درمان» متوقف شده و نوبت تازه روی آن گرفته نمی‌شود. نوبت را بدون بسته ثبت کنید، یا اول بازگشت مراجع را ثبت کنید.',
  'bk.packageStopped': 'با «پایان درمان» متوقف شده و برای نوبت تازه پیشنهاد نمی‌شود: {names}.',
  'bk.v.BOOKING_PACKAGE_ITEM_MISMATCH': 'آن سطر بسته مال این مراجع و این خدمت نیست.',
  'bk.v.BOOKING_ALREADY_DELIVERED':
    'این جلسه برگزار شده — نوبتِ برگزارشده سابقهٔ ثابت است و تغییر نمی‌کند.',
  'bk.v.BOOKING_NOT_ACTIVE': 'این نوبت دیگر زنده نیست.',
  'bk.v.other': 'سامانه مرکز نپذیرفت: {code}.',

  'bk.detailTitle': 'نوبت',
  'bk.when': 'چه زمانی',
  'bk.packageLine':
    '{name} — {planned} برنامه‌ریزی‌شده · {delivered} ارائه شده · {scheduled} برنامه‌ریزی‌شده · {remaining} برای برنامه‌ریزی',
  'bk.noPackageLine': 'موردی — بدون بسته',
  'bk.colourNote': 'نام خدمت همیشه این‌جا و روی تقویم نوشته می‌شود — رنگ هیچ‌وقت تنها نمی‌آید.',
  'bk.reschedule': 'جابه‌جایی نوبت',
  'bk.cancel': 'لغو نوبت',
  'bk.noShow': 'ثبت نیامدن',
  'bk.threeTitle': 'فقط سه وضعیت',
  'bk.threeBody':
    'نوبت فقط رزروشده، لغوشده یا نیامدن است. در انتظار، تأییدشده، پذیرش‌شده و «در جریان» وجود ندارد؛ برگزارشدنِ جلسهٔ گذشته از سند جلسه مشتق می‌شود.',
  'bk.sameKeyTitle': 'لغو و نیامدن هم‌سطح‌اند',
  'bk.sameKeyBody':
    'هر دو برگشت‌ناپذیرند و دلیلِ اختیاری می‌گیرند — و هیچ‌کدام جلسه‌ای از بسته مصرف نمی‌کنند؛ جلسهٔ برنامه‌ریزی‌شده دوباره قابل نوبت‌گذاری می‌ماند. تفاوت‌شان معناست: لغو یعنی قرار به‌هم خورد؛ نیامدن یعنی قرار سر جایش بود و مراجع نیامد.',
  'bk.deliveredNote':
    'برگزار شد — از سند جلسه مشتق شده؛ این نوبت اکنون سابقهٔ ثابت است و جابه‌جا یا لغو نمی‌شود (اگر اشتباه بود، اول برگزاری را باطل کنید).',
  'bk.reason': 'دلیل',
  'bk.reasonGiven': 'دلیل داده‌شده: {reason}',
  'bk.createdLine': 'رزرو شده توسط {who} · {date}',
  'bk.cancelTitle': 'این نوبت لغو شود؟',
  'bk.cancelBody':
    'بازه همان لحظه آزاد می‌شود و جلسهٔ برنامه‌ریزی‌شدهٔ بسته به «مانده» برمی‌گردد. لغو برگشت‌ناپذیر است — نوبت به‌عنوان سابقه، لغوشده می‌ماند و هر وقت خواستید نوبت تازه بگیرید. هزینه‌ای ندارد.',
  'bk.keep': 'نگه دار',
  'bk.noShowTitle': 'این جلسه «نیامدن» ثبت شود؟',
  'bk.noShowBody':
    'مثل لغو، جلسه‌ای از بسته مصرف نمی‌شود و جلسهٔ برنامه‌ریزی‌شده دوباره قابل نوبت‌گذاری می‌ماند؛ فرقش معنایی است: قرار سر جایش بود و مراجع نیامد. این ثبت برگشت‌ناپذیر است و نوبت با وضعیت «نیامد» دیدنی می‌ماند.',
  'bk.goBack': 'برگشت',
  'bk.openPatient': 'باز کردن پرونده',
  'bk.openPackage': 'باز کردن بسته',

  'bk.rsTitle': 'جابه‌جایی نوبت',
  'bk.rsSub':
    'زمان، درمانگر و شیوهٔ ارائهٔ همین نوبت عوض می‌شود — نوبت تازه‌ای ساخته نمی‌شود و جابه‌جایی جلسه‌ای از بسته مصرف نمی‌کند.',
  'bk.rsWhere': 'کجا و چه زمانی',
  'bk.rsDurationHelp': 'همان می‌ماند مگر این‌که عوضش کنید.',
  'bk.rsPractitionerHelp': 'می‌تواند به درمانگر توانمند دیگری منتقل شود.',
  'bk.rsModeHelp':
    'فیلدها از شیوه پیروی می‌کنند: «در محل مراجع» اتاق را با نشانی ویزیت و زمان سفر عوض می‌کند؛ «در مرکز» اتاق اختیاری را برمی‌گرداند — هیچ‌وقت خودکار انتخاب نمی‌شود.',
  'bk.rsCta': 'جابه‌جا کن',
  'bk.rsUnchanged': 'هنوز چیزی عوض نشده — اول زمان، درمانگر، اتاق یا شیوه ارائه را تنظیم کنید.',
  'bk.rsNote': 'محدودیت‌های سخت هنگام ذخیره دوباره بررسی می‌شوند — رد شدن چیزی را از بین نمی‌برد.',
  'bk.rsNoServiceTitle': 'خدمت و بسته این‌جا عوض نمی‌شوند — فعلا',
  'bk.rsNoServiceBody':
    'جابه‌جایی، زمان، درمانگر، اتاق و شیوهٔ همین نوبت را عوض می‌کند. خدمت و بسته همان می‌مانند که رزرو شده — برای تغییرشان، نوبت را لغو و از نو رزرو کنید.',
  'bk.rsLocked': 'این نوبت جابه‌جا نمی‌شود: {why}',

  'rec.bookingsSub': 'همهٔ نوبت‌های این پرونده، تازه‌ترین اول.',
  'rec.noBookings': 'هنوز نوبتی نیست. نوبت اول از تقویم گرفته می‌شود.',
  'rec.newBooking': 'جلسه جدید',

  'hours.affected':
    '{n, plural, =0 {هیچ جلسه رزرو شده‌ای داخل این مرخصی نمی‌افتد.} one {# جلسه رزرو شده داخل این مرخصی می‌افتد — تقویم را باز کنید تا جابه‌جایش کنید.} other {# جلسه رزرو شده داخل این مرخصی می‌افتد — تقویم را باز کنید تا جابه‌جایشان کنید.}}',
  'md.title': 'روزِ من',
  'md.sub': 'برنامه خودتان، روی هر صفحه.',
  'md.summary':
    '{n, plural, =0 {امروز جلسه‌ای نیست} one {# جلسه} other {# جلسه}}{home, plural, =0 {} one { · یکی در محل خانه یک خانواده} other { · # در محل خانه خانواده‌ها}}',
  'md.empty': 'امروز چیزی در برنامه شما نیست.',
  'md.stale': 'همین حالا به‌روز نشد — این برنامه شماست همان‌طور که آخرین بار بارگذاری شد.',
  'md.notPractitioner': 'حساب شما امروز جلسه خودش را ندارد. تقویم مرکز برنامه همه را نشان می‌دهد.',
  'md.openCalendar': 'باز کردن تقویم',
  'md.addressOnBooking': 'نشانی روی نوبت',
  'md.packageLeft': '{name} · {n} باقی‌مانده برای برنامه‌ریزی',

  'sp.title': 'برنامه‌ریزی جلسات باقی‌مانده {name}',
  'sp.sub':
    'برای {line} — {n, plural, one {# جلسه} other {# جلسه}} باقی‌مانده برای برنامه‌ریزی. پیشنهادها مشورتی اند: آزادانه ویرایش یا نادیده شان بگیرید.',
  'sp.none': 'چیزی برای برنامه‌ریزی روی این سطر نمانده.',
  'sp.strategy.preferred_fit': 'تناسب ترجیحی',
  'sp.strategy.preferred_fitBody': 'بر زمان‌های معمول خانواده و درمانگر ترجیحی تکیه می‌کند.',
  'sp.strategy.steady_rhythm': 'ریتم ثابت',
  'sp.strategy.steady_rhythmBody': 'همان روز هفته و همان ساعت هر هفته — حتی اگر دیرتر تمام شود.',
  'sp.strategy.soonest_completion': 'سریع‌ترین تکمیل',
  'sp.strategy.soonest_completionBody': 'زودترین بازه‌های آزاد، حتی بین درمانگران مختلف.',
  'sp.prefs': 'ترجیحات (نرم — فقط رتبه‌بندی)',
  'sp.prefPractitioner': 'درمانگر ترجیحی',
  'sp.prefRoom': 'اتاق ترجیحی',
  'sp.prefRoomHelp':
    'پیشنهادها اتاقی ندارند مگر این‌جا یکی نام ببرید؛ حمل می‌شود، هیچ‌وقت انتخاب نمی‌شود.',
  'sp.horizon': 'برنامه‌ریزی پیش رو (روز)',
  'sp.planHead': 'یک پیشنهاد برای {n, plural, one {# جلسه} other {# جلسه}}',
  'sp.planSub':
    'امتیاز، دلایل و بده‌بستان هر پیشنهاد با کلمات انسانی نوشته می‌شود. هر جلسه می‌تواند نگه داشته یا کنار گذاشته شود. پیشنهادها اتاقی ندارند — زمان‌بند هیچ‌وقت اتاقی جستجو یا انتخاب نمی‌کند.',
  'sp.fitWell': 'تناسب خوب · {score}',
  'sp.fit': 'تناسب · {score}',
  'sp.keep': 'نگه‌داشتن',
  'sp.incomplete':
    'نتوانست همه جلسات را در این افق جا دهد — افق را گسترش دهید یا بقیه را بعدا برنامه‌ریزی کنید.',
  'sp.rhythmBroken': 'ریتم هفتگی دست‌کم یک‌بار در این افق می‌شکند.',
  'sp.apply': 'اعمال {n, plural, one {# جلسه} other {# جلسه}}',
  'sp.refresh': 'تازه‌کردن پیشنهادها',
  'sp.applyNote':
    'با هم اعمال می‌شوند یا اصلا — و هر بازه هنگام ذخیره دوباره با محدودیت‌های سخت بررسی می‌شود.',
  'sp.staleTitle': 'چیزی اعمال نشد',
  'sp.staleBody':
    'دسته همه‌یاهیچ است: بازه‌ای هنگام اعمال گرفته شده بود، پس هیچ جلسه‌ای ثبت نشد و برنامهٔ شما دست‌نخورده مانده. ردیف‌هایی که دیگر پیشنهاد نمی‌شوند علامت خورده‌اند؛ تازه کنید و دوباره اعمال کنید.',
  'sp.staleRow': 'بازه از آن موقع گرفته شد',
  'sp.applied': '{n, plural, one {# جلسه} other {# جلسه}} رزرو شد.',
  'sp.appliedWarn': 'برخی از نوبت‌هایی که همین حالا ثبت شد اطلاعی به همراه دارند:',
  'sp.advisoryTitle': 'مشورتی، هیچ‌وقت تصمیم گیرنده',
  'sp.advisoryBody':
    'پذیرش می‌تواند هر پیشنهاد را ویرایش کند یا نادیده بگیرد؛ قیدهای سخت همچنان هنگام ثبت نهایی تصمیم می‌گیرند. تماس اول هرگز از اینجا نمی‌گذرد — نوبت اول همیشه دستی و از تقویم است.',
  'sp.planLine': 'برنامه‌ریزی جلسه‌های مانده',
  'sp.r.PREFERRED_PROVIDER': 'درمانگر ترجیحی برای این خدمت',
  'sp.r.STRONG_CAPABILITY_MATCH': 'تطبیق توانایی قوی',
  'sp.r.USUAL_PRACTITIONER': 'همان درمانگر قبلی',
  'sp.r.AVAILABLE_SOON': 'به‌زودی در دسترس',
  'sp.r.LOW_PRACTITIONER_LOAD': 'بار سبک‌تر برای این درمانگر',
  'sp.r.MATCHES_PREFERRED_PRACTITIONER': 'درمانگر ترجیحی شما',
  'sp.r.MATCHES_PREFERRED_ROOM': 'اتاق ترجیحی شما',
  'sp.r.MATCHES_PREFERRED_WEEKDAY': 'روز هفته ترجیحی',
  'sp.r.MATCHES_PREFERRED_TIME_WINDOW': 'ساعت ترجیحی روز',
  'sp.t.DIFFERENT_PRACTITIONER_THAN_USUAL': 'درمانگری متفاوت از معمول',
  'sp.t.DIFFERENT_PRACTITIONER_THAN_PREFERRED': 'نه درمانگر ترجیحی',
  'sp.t.DIFFERENT_ROOM_THAN_PREFERRED': 'نه اتاق ترجیحی',
  'sp.t.OUTSIDE_PREFERRED_WEEKDAYS': 'خارج از روزهای هفته ترجیحی',
  'sp.t.OUTSIDE_PREFERRED_TIME_WINDOWS': 'خارج از ساعات ترجیحی',
  'sp.tradeoff': 'بده‌بستان: {text}.',
  'sp.reason': '{text}.',
  /* چرخهٔ اجرای جلسه (ZOY-546/551). */
  'bk.status.incomplete': 'تکمیل‌نشده',
  'bk.exec.in_progress': 'در حال انجام',
  'bk.startCta': 'شروع جلسه',
  'bk.startTitle': 'آیا جلسه شروع شود؟',
  'bk.startBody': 'شروع، زمان و نام شما را ثبت می‌کند و کار بالینی داخل همین جلسه پیش می‌رود.',
  'bk.yes': 'بله',
  'bk.no': 'خیر',
  'bk.startedLine': 'شروع‌شده توسط {who} · {date}',
  'bk.err.alreadyStarted': 'این جلسه از قبل شروع‌شده بود — وضعیت فعلی اش نشان داده می‌شود.',
  'bk.guestNoStart':
    'ثبت‌نام این مراجع کامل نیست، بنابراین جلسه بالینی شروع نمی‌شود. ثبت‌نام از پرونده مراجع کامل می‌شود؛ خود رزرو معتبر می‌ماند.',
  'bk.incCta': 'ثبت به‌عنوان تکمیل‌نشده',
  'bk.incTitle': 'این جلسه به‌عنوان ناقص بسته شود؟',
  'bk.incBody':
    'ویزیت انجام شد اما کار بالینی کامل نشد. چیزی قابل پرداخت نیست، پیشرفت بسته جابه‌جا نمی‌شود، و جلسه هیچ‌وقت بعدا به‌عنوان ارائه شده ثبت نمی‌شود.',
  'bk.incReason': 'چرا جلسه کامل نشد',
  'bk.err.notStarted':
    'فقط جلسه‌ای که شروع‌شده می‌تواند به‌عنوان ناقص بسته شود — جلسه‌ای که هیچ‌وقت انجام نشد، لغو است.',
  'bk.assessNeeded': 'کامل کردن این جلسه به ارزیابی امضا شده خود همین جلسه نیاز دارد.',
  // Smart Scheduling v2 (ZOY-682)
  'sp.subPackage':
    '{pkg} — {n, plural, one {# جلسه} other {# جلسه}} باقی‌مانده در {k, plural, one {# خدمت} other {# خدمت}}. گزینه‌ها را انتخاب کنید؛ پیشنهادها داخل آن‌ها ساخته می‌شوند.',
  'sp.opt.title': 'گزینه‌های زمان‌بندی',
  'sp.opt.sub': 'همیشه: یک جلسه از هر خدمت در روز، و حداکثر دو جلسه در روز.',
  'sp.opt.dayPattern': 'الگوی روز',
  'sp.opt.fastest': 'سریع‌ترین',
  'sp.opt.weekdays': 'روزهای هفته انتخاب‌شده',
  'sp.opt.weekdaysHelp': 'هر روز انتخاب‌شده حداکثر یک جلسه از هر خدمت دارد.',
  'sp.opt.weekdaysNeeded': 'دست‌کم یک روز انتخاب کنید.',
  'sp.opt.presetEven': 'روزهای زوج',
  'sp.opt.presetOdd': 'روزهای فرد',
  'sp.opt.therapist': 'درمانگر',
  'sp.opt.tAny': 'هر درمانگر توانمند',
  'sp.opt.tUsual': 'درمانگر معمول',
  'sp.opt.tSpecific': 'درمانگر مشخص',
  'sp.opt.tFor': 'درمانگر برای {service}',
  'sp.opt.therapistNeeded': 'برای هر خدمت یک درمانگر انتخاب کنید.',
  'sp.wd.1': 'دوشنبه',
  'sp.wd.2': 'سه‌شنبه',
  'sp.wd.3': 'چهارشنبه',
  'sp.wd.4': 'پنجشنبه',
  'sp.wd.5': 'جمعه',
  'sp.wd.6': 'شنبه',
  'sp.wd.7': 'یکشنبه',
  'sp.model.soonest_completion': 'سریع‌ترین تکمیل',
  'sp.model.soonest_completionBody': 'بسته زودتر تمام می‌شود.',
  'sp.model.steady_time': 'ساعت ثابت',
  'sp.model.steady_timeBody': 'همان ساعت روز برای هر جلسه تا حد امکان.',
  'sp.model.best_fit': 'بهترین تناسب',
  'sp.model.best_fitBody': 'درمانگر معمول، بیشترین جفت شدن در یک روز، بار متعادل.',
  'sp.unavailableSpecific':
    'با درمانگر انتخاب‌شده هیچ برنامه کامل ممکن نیست، بنابراین تحت این گزینه چیزی پیشنهاد نمی‌شود. درمانگر یا الگوی روز را عوض کنید.',
  'sp.noPlans': 'در این افق هیچ برنامه‌ای ساخته نشد.',
  'sp.horizonNote': 'افق جستجو: {days, number} روز',
  'sp.paired': 'دو جلسه پشت سر هم',
  'sp.notPaired': 'جفت نشده',
  'sp.noUsual':
    'برای هر خدمت درمانگر معمولی شناخته‌شده نیست؛ برای آن‌ها هر درمانگر توانمندی استفاده شد.',
  'sp.steadyNotHeld': 'یک ساعت روز برای همه جلسات نگه داشته نشد.',
  'sp.applyBatches': 'بیش از {max, number} جلسه در دسته‌ها اعمال می‌شوند؛ هر دسته همه یا هیچ است.',
  'sp.appliedPartial': '{n, number} جلسه اعمال شد؛ دسته بعدی رد شد.',
  'sp.r.PAIRED_SAME_DAY': 'پشت سر هم با خدمت دیگر',
  'sp.t.NOT_PAIRED_ON_DAY': 'جفت نشده با خدمت دیگر آن روز',
  // ZOY-685/686: the group occurrence — one session, its attendees.
  'grp.newTitle': 'جلسهٔ گروهی تازه',
  'grp.newSub':
    'یک جلسه، چند شرکت‌کننده — مثل یک رویداد تقویمی. خدمت گروهی، درمانگر، زمان و شیوه را انتخاب کنید؛ شرکت‌کنندگان را بعدا اضافه کنید. هر شرکت‌کننده بسته و پرداخت خودش را نگه می‌دارد.',
  'grp.service': 'خدمت گروهی',
  'grp.serviceHelp': 'فقط خدماتی با گردش‌کار گروهی.',
  'grp.noGroupServices':
    'هنوز خدمت گروهی فعالی نیست — یکی در تنظیمات مرکز › خدمات با گردش‌کار «جلسه گروهی» بسازید.',
  'grp.capacity': 'ظرفیت',
  'grp.capacityHelp': 'حداکثر شرکت‌کنندگان. از خدمت پیش‌پر می‌شود؛ تا {cap, number} برای این شیوه.',
  'grp.createCta': 'ساختن جلسه گروهی',
  'grp.step2': '۲ · زمان، درمانگر، مکان',
  'grp.title': 'جلسه گروهی',
  'grp.sub': 'جلسه و شرکت کنندگانش. ارائه، نتیجه و پرداخت برای هر شرکت‌کننده جداگانه می‌ماند.',
  'grp.attendees': 'شرکت‌کننده‌ها',
  'grp.attendeesSub':
    'فقط مراجعان ثبت‌شده. هر کدام سطر بسته خودش یا قیمت موردی خودش را نگه می‌دارد.',
  'grp.add': 'افزودن شرکت‌کننده',
  'grp.addSearch': 'یافتن مراجع ثبت‌نام‌شده',
  'grp.addSearchHelp':
    'نام خانوادگی، شماره پرونده یا موبایل. مهمان‌ها نمی‌توانند به جلسه گروهی بپیوندند.',
  'grp.addNone': 'مراجع ثبت‌نام‌شده‌ای پیدا نشد.',
  'grp.addPick': 'افزودن',
  'grp.addPackageTitle': 'این شرکت‌کننده از کدام بسته استفاده کند؟',
  'grp.addCta': 'افزودن به جلسه',
  'grp.full': 'جلسه پر است ({cap, number}).',
  'grp.remove': 'برداشتن',
  'grp.removeTitle': 'این شرکت‌کننده حذف شود؟',
  'grp.removeBody':
    'نوبتش لغو می‌شود (چیزی از بسته مصرف نمی‌شود) و فقط از همین جلسه بیرون می‌رود. پیش از شروع ممکن است.',
  'grp.noAttendees': 'هنوز شرکت‌کننده‌ای نیست — اولین را اضافه کنید.',
  'grp.start': 'شروع جلسه گروهی',
  'grp.startTitle': 'جلسه گروهی شروع شود؟',
  'grp.startBody':
    'جلسه هر شرکت‌کننده ثبت‌شده الان، به‌نام شما، شروع می‌شود. ارائه بعدا برای هر شرکت‌کننده جداگانه ثبت می‌شود.',
  'grp.startedNot': '{n, plural, one {# شرکت‌کننده} other {# شرکت‌کننده}} شروع نشد (ثبت‌نام ناقص).',
  'grp.end': 'پایان جلسه گروهی',
  'grp.endTitle': 'جلسه گروهی تمام شود؟',
  'grp.endBody': 'جلسه تمام است. هر شرکت‌کننده همچنان روی نوبت خودش برگزار، غایب یا بسته می‌شود.',
  'grp.cancel': 'لغو جلسه گروهی',
  'grp.cancelTitle': 'جلسه گروهی لغو شود؟',
  'grp.cancelBody':
    'نوبت هر شرکت‌کننده با آن لغو می‌شود. برگشت‌ناپذیر؛ چیزی از هیچ بسته‌ای مصرف نمی‌شود.',
  'grp.cancelled': 'این جلسه گروهی لغو شد.',
  'grp.move': 'جابه‌جایی جلسه',
  'grp.moveSub': 'زمان، درمانگر، اتاق و مقصد — همه شرکت‌کنندگان دنبال می‌کنند. بعد از شروع نه.',
  'grp.moveCta': 'جابه‌جا کردن جلسه گروهی',
  'grp.deliver': 'ثبت برگزاری',
  'grp.noShow': 'غیبت',
  'grp.viewBooking': 'نوبت',
  'grp.guestSkipped': 'ثبت‌نام ناقص — شروع نشد',
  'grp.reportTitle': 'گزارش گروه',
  'grp.reportSub':
    'یک گزارش برای کل جلسه، یک‌بار توسط درمانگر اصلی بعد از شروع نوشته می‌شود؛ بعد از آن روی ثبت جلسه هر شرکت‌کننده ظاهر می‌شود. یادداشت‌های خصوصی روی ارائه هر شرکت‌کننده می‌مانند.',
  'grp.reportWrite': 'نوشتن گزارش گروه',
  'grp.reportPh': 'گروه روی چه چیزی کار کرد، جلسه چطور گذشت…',
  'grp.reportCta': 'ذخیره گزارش — نهایی',
  'grp.reportNote': 'یک‌بار نوشتن، مثل یادداشت‌های جلسه: بعد از آن ویرایش یا حذف نیست.',
  'grp.reportBy': 'نوشته شده توسط {who} · {when}',
  'grp.reportNone': 'هنوز گزارشی نیست.',
  'grp.reportBeforeStart': 'گزارش بعد از شروع جلسه نوشته می‌شود.',
  'grp.reportNotLeading': 'فقط درمانگر اصلی گزارش گروه را می‌نویسد.',
  'grp.movedNote': 'نوبت هر شرکت‌کننده همراه جلسه جابه‌جا شد.',
  'grp.facts.capacity': 'ظرفیت',
  'grp.facts.therapist': 'درمانگر اصلی',
  'grp.step3': '۳ · شرکت‌کنندگان',
  'grp.draftSub':
    'فقط شرکت‌کنندگان همین جلسه — مراجعان ثبت‌شده، برای هر جلسه از نو انتخاب می‌شوند. هر کدام بسته یا قیمت موردی خودش را نگه می‌دارد.',
  'grp.draftNone': 'هنوز شرکت‌کننده‌ای انتخاب نشده.',
  'grp.draftRemove': 'حذف',
  'grp.draftCount':
    '{n, plural, =0 {بدون شرکت‌کننده} one {# شرکت‌کننده} other {# شرکت‌کننده}} · {cap, number} جا',
  'grp.createWith':
    '{n, plural, =0 {ساختن جلسه گروهی} one {ساختن با # شرکت‌کننده} other {ساختن با # شرکت‌کننده}}',
  'grp.emptyTitle': 'جلسه گروهی بدون شرکت‌کننده ساخته شود؟',
  'grp.emptyBody':
    'جلسه خالی ساخته می‌شود؛ شرکت‌کنندگان می‌توانند تا شروع، در صفحه جلسه اضافه شوند. معمولا همین حالا انتخاب می‌شوند.',
  'grp.emptyCta': 'ساختن بدون شرکت‌کننده',
  'grp.addFailedTitle':
    'جلسه ساخته شد، اما {n, plural, one {# شرکت‌کننده} other {# شرکت‌کننده}} اضافه نشد',
  'grp.addFailedLine': '{name}: {reason}',
  'grp.addFailedUnknown':
    'پاسخی از سرور نیامد — فهرست زیر را بررسی کنید و در صورت نیاز دوباره اضافه کنید',
  'grp.addFailedDismiss': 'متوجه شدم',
  'grp.err.GROUP_SESSION_FULL': 'جلسه پر است.',
  'grp.err.GROUP_SESSION_PATIENT_ALREADY_IN': 'این مراجع از قبل در جلسه است.',
  'grp.err.GROUP_SESSION_CAPACITY_EXCEEDS_LIMIT': 'ظرفیت از حد این شیوه بیشتر است.',
  'grp.err.GROUP_SESSION_CAPACITY_REQUIRED': 'یک ظرفیت تعیین کنید — خدمت پیش‌فرضی ندارد.',
  'grp.err.GROUP_SESSION_MODE_NOT_ALLOWED':
    'جلسه گروهی در مرکز یا آنلاین است — هیچ‌وقت در محل مراجع.',
  'grp.err.GROUP_SESSION_SERVICE_NOT_GROUP': 'این خدمت خدمت گروهی نیست.',
  'grp.err.GROUP_SESSION_PARTICIPANT_OVERLAP':
    'جابه‌جایی یک شرکت‌کننده را هم‌زمان در دو جلسه قرار می‌دهد.',
  'grp.err.GROUP_SESSION_NOT_ACTIVE': 'این جلسه گروهی لغو شده است.',
  'grp.err.GROUP_SESSION_ALREADY_STARTED': 'جلسه گروهی از قبل شروع‌شده است.',
  'grp.err.GROUP_SESSION_NOT_STARTED': 'جلسه گروهی هنوز شروع نشده است.',
  'grp.err.GROUP_SESSION_ALREADY_ENDED': 'جلسه گروهی از قبل تمام‌شده است.',
  'grp.err.GROUP_SESSION_ONLINE_SESSION_LOCKED':
    'جلسه آنلاین از قبل باز شده؛ دیگر نمی‌توان آن را جابه‌جا یا لغو کرد یا خالی کرد.',
  'grp.err.GROUP_REPORT_ALREADY_WRITTEN': 'گزارش گروه از قبل نوشته شده.',
  'grp.err.GROUP_SESSION_PRACTITIONER_OVERLAP': 'درمانگر در این بازه نوبت دیگری دارد.',
  'grp.err.GROUP_SESSION_ROOM_OVERLAP': 'اتاق در این بازه نوبت دیگری دارد.',
  'grp.err.BOOKING_PATIENT_OVERLAP': 'این مراجع در آن زمان جلسهٔ دیگری دارد.',
  // ZOY-696: the therapist's hosted-video surface.
  'live.title': 'جلسه زنده',
  'live.role.host': 'میزبان',
  'live.role.cohost': 'هم‌میزبان',
  'live.connecting': 'در حال اتصال به اتاق ویدیو…',
  'live.permissions': 'برای ورود با ویدیو به مجوز دوربین و میکروفون نیاز است.',
  'live.permissionDenied':
    'دوربین یا میکروفون رد شد — شما بدون رسانه در اتاق هستید. آن‌ها را در مرورگر اجازه دهید و دوباره وارد شوید.',
  'live.notConfigured': 'سکوی ویدئو برای این استقرار تنظیم نشده.',
  'live.you': 'شما',
  'live.leave': 'خروج',
  'live.end': 'پایان برای همه',
  'live.endTitle': 'جلسه برای همه تمام شود؟',
  'live.endBody':
    'همهٔ خانواده‌ها قطع می‌شوند و اتاق بسته می‌شود. برگزاری همچنان بعداً روی نوبت ثبت می‌شود.',
  'live.mic': 'میکروفون',
  'live.cam': 'دوربین',
  'live.on': 'روشن',
  'live.off': 'خاموش',
  'live.stage': 'روی صحنه',
  'live.audience':
    '{n, plural, =0 {کسی در مخاطبان نیست} one {# نفر در مخاطبان} other {# نفر در مخاطبان}}',
  'live.hands': 'دست‌های بالا',
  'live.invite': 'دعوت به صحنه',
  'live.dismissHand': 'رد کردن',
  'live.mute': 'بی‌صدا',
  'live.toAudience': 'به تماشاگران',
  'live.remove': 'حذف',
  'live.promote': 'هم‌میزبان کن',
  'live.reconnecting': 'اتصال قطع شد — در حال اتصال دوباره…',
  'live.ended': 'جلسه تمام شد.',
  'live.removed': 'شما از جلسه حذف شدید.',
  'live.noRecording': 'این جلسه ضبط نمی‌شود.',
  'live.controlFailed': 'انجام نشد — دوباره بزنید.',
  'live.backTo': 'بازگشت به نوبت',

  /* ── برگهٔ جلسه (کارهای سریع روی تقویم) ───────────────────────────── */
  'sheet.title': 'جلسه',
  'sheet.close': 'بستن',
  'sheet.openFull': 'جزئیات کامل',
  'sheet.back': '← بازگشت به جلسه',
  'sheet.payment': 'پرداخت',
  'sheet.owed': '{amount} باقی‌مانده',
  'sheet.guest': 'مهمان',
  'sheet.done.cancel': 'لغو شد — تقویم به‌روز شد.',
  'sheet.done.no_show': 'غیبت علامت خورد — تقویم به‌روز شد.',
  'sheet.done.paid': 'پرداخت ثبت شد.',
  'sheet.done.moved': 'جابه‌جا شد — تقویم به‌روز شد.',
  'md.unrec.title': 'گزارش‌های ثبت‌نشده',
  'md.unrec.sub': 'جلسات {days, number} روز گذشته شما که زمانشان گذشته و هنوز گزارشی ندارند.',
  'md.unrec.groupReport': 'گزارش گروه نوشته نشده',
  'md.unrec.record': 'ثبت گزارش',
  'md.unrec.writeGroup': 'نوشتن گزارش گروه',
  'sheet.extras': 'هزینه‌های اضافی',
  'cal.print.open': 'چاپ / PDF',
  'cal.print.title': 'چاپ برنامه',
  'cal.print.sub':
    'یک برگ A4. در پنجرهٔ چاپ، چاپگر را انتخاب کنید — یا «ذخیره به‌صورت PDF» را برای نگه‌داشتن فایل.',
  'cal.print.kind': 'برنامه',
  'cal.print.kind.day': 'روزانه',
  'cal.print.kind.week': 'هفتگی',
  'cal.print.whichDay': 'کدام روز',
  'cal.print.whichWeek': 'کدام هفته',
  'cal.print.today': 'امروز',
  'cal.print.tomorrow': 'فردا',
  'cal.print.otherDay': 'روز دیگر',
  'cal.print.thisWeek': 'این هفته',
  'cal.print.nextWeek': 'هفتهٔ بعد',
  'cal.print.otherWeek': 'هفتهٔ دیگر',
  'cal.print.date': 'تاریخ',
  'cal.print.weekOf': 'یک روز از آن هفته',
  'cal.print.who': 'درمانگر',
  'cal.print.all': 'همهٔ درمانگرها',
  'cal.print.count': '{n, plural, one {# جلسه} other {# جلسه}} در این بازه',
  'cal.print.none': 'در این بازه جلسه‌ای نیست.',
  'cal.print.go': 'چاپ / ذخیرهٔ PDF',
  'cal.print.dayTitle': 'برنامهٔ روز — {date}',
  'cal.print.weekTitle': 'برنامهٔ هفته — {from} تا {to}',
  'cal.print.forWho': 'درمانگر: {name}',
  'cal.print.printedAt': 'چاپ: {when}',
  'cal.print.colTherapist': 'درمانگر',
  'cal.print.colDay': 'روز',
  'cal.print.layout': 'شکل چاپ هفته',
  'cal.print.layout.grid': 'جدولی (مثل روزانه)',
  'cal.print.layout.list': 'به تفکیک درمانگر',
  'cal.print.layout.gridAllHint':
    'هر روز در یک صفحهٔ جدا، مثل چاپ روزانه: درمانگرها در ردیف‌ها و ساعت‌ها در ستون‌ها.',
  'cal.print.layout.gridOneHint': 'یک صفحه: روزها در ردیف‌ها و ساعت‌ها در ستون‌ها.',
  'cal.print.layout.listHint':
    'برای هر درمانگر یک بخش؛ جلسهٔ تکراری در چند روز هفته در یک خط می‌آید.',
  'cal.print.span': '{from} تا {to}',
  'cal.print.group': 'گروهی',
  'cal.print.sessions': '{n, plural, one {# جلسه} other {# جلسه}}',
  'bk.pick.offeredHelp': 'درمانگرانی که این خدمت را ارائه می‌دهند و در این زمان ساعت کاری دارند.',
  'bk.pick.none': 'هیچ درمانگرِ این خدمت در این زمان ساعت کاری ندارد — پایین با نام جست‌وجو کنید.',
  'bk.pick.search': 'درمانگر دیگر',
  'bk.pick.searchHelp':
    'جست‌وجو با نام — {n, plural, one {# درمانگرِ} other {# درمانگرِ}} این خدمت که این زمان خارج از ساعت کاری‌شان است.',
  'bk.pick.outside': 'خارج از ساعت کاری این درمانگر',
  'bk.pick.timeOff': 'این درمانگر در این زمان مرخصی است',
  'bk.pick.choose': 'انتخاب',
  'bk.pick.noMatch': 'موردی پیدا نشد.',
  // 2026-10-14: payment before delivery, from the sheet (general credit).
  'sheet.prepay': 'ثبت پرداخت',
  'sheet.done.prepaid': 'پرداخت در حساب مراجع ثبت شد.',
  // 2026-10-18: repeat a new booking on chosen weekdays.
  'bk.rep.toggle': 'تکرار',
  'bk.rep.toggleHelp':
    'همین جلسه در همین ساعت، در روزهای انتخابی هفته ثبت می‌شود — هر تاریخ یک نوبت جداست.',
  'bk.rep.on': 'روشن',
  'bk.rep.off': 'خاموش',
  'bk.rep.days': 'در این روزها',
  'bk.rep.every': 'هر چند وقت',
  'bk.rep.every.1': 'هر هفته',
  'bk.rep.every.2': 'یک هفته در میان',
  'bk.rep.every.3': 'دو هفته در میان',
  'bk.rep.every.4': 'ماهی یک‌بار',
  'bk.rep.count': 'تعداد جلسه',
  'bk.rep.countHelp': 'از ۱ تا {max, number}، از تاریخ همین نوبت.',
  'bk.rep.spanMonths': 'حدود {n, plural, one {# ماه} other {# ماه}} جلسه.',
  'bk.rep.spanYears': 'حدود {n, plural, one {# سال} other {# سال}} جلسه.',
  'bk.rep.fill': 'تکمیل تعداد با تاریخ‌های بعدی',
  'bk.rep.fillHelp': 'به‌جای هر تاریخِ تیک‌نخورده، تاریخ بعدیِ همین الگو اضافه می‌شود.',
  'bk.rep.replacing': '{n, plural, one {# جلسهٔ جایگزین} other {# جلسهٔ جایگزین}} از {date}.',
  'bk.rep.previewTitle': 'تاریخ‌ها',
  'bk.rep.chosen': '{n, plural, one {# تاریخ انتخاب شده} other {# تاریخ انتخاب شده}}',
  'bk.rep.progress': 'در حال ثبت {done, number} از {total, number}…',
  'bk.rep.free': 'آزاد',
  'bk.rep.issue.holiday': 'تعطیل رسمی',
  'bk.rep.issue.outside_hours': 'خارج از ساعت کاری',
  'bk.rep.issue.time_off': 'درمانگر مرخصی است',
  'bk.rep.issue.practitioner_busy': 'درمانگر نوبت دیگری دارد',
  'bk.rep.issue.patient_busy': 'مراجع نوبت دیگری دارد',
  'bk.rep.save': '{n, plural, =0 {ثبت جلسه‌ها} one {ثبت # جلسه} other {ثبت # جلسه}}',
  'bk.rep.booked': 'ثبت شد',
  'bk.rep.notBooked': 'ثبت نشد',
  'bk.rep.unknown': 'نامعلوم — تقویم را ببینید',
  'bk.rep.summary':
    '{booked, plural, one {# جلسه ثبت شد} other {# جلسه ثبت شد}}؛ {failed, plural, =0 {همه ثبت شدند} one {# جلسه ثبت نشد} other {# جلسه ثبت نشد}}.',
  'bk.rep.overPlan': '{n, plural, one {# جلسه} other {# جلسه}} بیش از برنامهٔ بسته ثبت شد.',
  'bk.rep.unknownNote':
    'تاریخی که «نامعلوم» است به‌موقع جواب نداد — ممکن است ثبت شده باشد؛ پیش از ثبت دوباره، تقویم را ببینید.',
  'bk.rep.replace': 'افزودن {n, plural, one {# جلسه} other {# جلسه}} بعد از {date} به‌جای آن‌ها',
  'bk.rep.needForm':
    'اول درمانگر، تاریخ و ساعت را بالا انتخاب کنید — تاریخ‌ها از آن‌ها ساخته می‌شوند.',
  'bk.rep.toCalendar': 'رفتن به تقویم',
  'bk.series.scope': 'همین جلسه یا سری',
  'bk.series.one': 'فقط همین جلسه',
  'bk.series.following': 'این و {n, plural, one {# جلسهٔ بعدی} other {# جلسهٔ بعدی}}',
  'bk.series.moveHelp':
    'جلسه‌های بعدیِ ثبت‌شدهٔ این سری هم همین‌طور جابه‌جا می‌شوند، هر کدام در هفتهٔ خودش — یکی‌یکی و هر کدام جداگانه بررسی می‌شود.',
  'bk.series.cancelHelp': 'جلسه‌های بعدیِ ثبت‌شدهٔ این سری هم یکی‌یکی لغو می‌شوند.',
  'bk.series.resultTitle': 'جلسه‌های بعدی سری',
  'bk.series.moved': 'جابه‌جا شد',
  'bk.series.to': '←',
  'bk.series.notMoved': 'جابه‌جا نشد',
  'bk.series.cancelled': 'لغو شد',
  'bk.series.notCancelled': 'لغو نشد',
  'bk.series.moveSummary':
    '{done, plural, one {# جلسهٔ بعدی جابه‌جا شد} other {# جلسهٔ بعدی جابه‌جا شد}}؛ {failed, plural, =0 {همه جابه‌جا شدند} one {# جلسه سر جای قبلی ماند} other {# جلسه سر جای قبلی ماندند}}.',
  'bk.series.cancelSummary':
    '{done, plural, one {# جلسهٔ بعدی لغو شد} other {# جلسهٔ بعدی لغو شد}}؛ {failed, plural, =0 {همه لغو شدند} one {# جلسه لغو نشد} other {# جلسه لغو نشد}}.',
  'bk.series.progress': 'در حال انجام {done, number} از {total, number}…',
  'bk.series.done': 'تمام',
  'grp.rep.toggleHelp':
    'همین جلسهٔ گروهی در همین ساعت، در روزهای انتخابی هفته و با همین شرکت‌کننده‌ها ساخته می‌شود — هر تاریخ یک جلسهٔ جداست.',
  'grp.rep.save':
    '{n, plural, =0 {ساختن جلسه‌ها} one {ساختن # جلسهٔ گروهی} other {ساختن # جلسهٔ گروهی}}',
  'grp.rep.summary':
    '{booked, plural, one {# جلسهٔ گروهی ساخته شد} other {# جلسهٔ گروهی ساخته شد}}؛ {failed, plural, =0 {همه ساخته شدند} one {# جلسه ساخته نشد} other {# جلسه ساخته نشد}}.',
  'grp.rep.overPlan':
    'در {n, plural, one {# تاریخ} other {# تاریخ}} شرکت‌کننده‌ای بیش از برنامهٔ بسته‌اش ثبت شد.',
  'grp.rep.notAdded': 'اضافه نشد: {names}',
  'grp.rep.notAddedTotal':
    '{n, plural, one {# شرکت‌کننده اضافه نشد} other {# شرکت‌کننده اضافه نشد}} — برای دیدن چه کسی و چرا، جلسه را باز کنید.',
};
